if (!customElements.get('about-store-gallery')) {
  customElements.define('about-store-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      const section = this.closest('.about-store');
      const description = this.querySelector('.about-store__text');
      if (section && description) {
        const content = description.textContent || '';
        const arabic = (content.match(/[\u0600-\u06ff]/g) || []).length;
        const latin = (content.match(/[A-Za-z\u00c0-\u024f]/g) || []).length;
        section.dir = section.lang.split('-')[0] === 'ar' || arabic > latin ? 'rtl' : 'ltr';
      }
      this.main = this.querySelector('.about-store__main-image');
      this.track = this.querySelector('.about-store__thumbnails');
      if (!this.main || !this.track) return;
      this.buttons = [...this.querySelectorAll('[data-about-image]')];
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.buttons.forEach(button => button.addEventListener('click', () => this.select(button), options));
      this.previous = this.querySelector('[data-about-prev]');
      this.next = this.querySelector('[data-about-next]');
      this.previous.addEventListener('click', () => this.step(-1), options);
      this.next.addEventListener('click', () => this.step(1), options);
      this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this.track);
      this.addEventListener('shopify:block:select', event => {
        const button = event.target.querySelector('[data-about-image]');
        if (button) this.select(button);
      }, options);
      this.update();
    }
    select(button) {
      if (matchMedia('(max-width: 749px)').matches) {
        const delta = button.getBoundingClientRect().left - this.track.getBoundingClientRect().left;
        this.track.scrollBy({ left: delta, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        this.buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        return;
      }
      this.main.removeAttribute('srcset');
      this.main.src = button.dataset.aboutImage;
      this.main.alt = button.dataset.aboutAlt;
      this.buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    }
    step(direction) {
      const rtl = getComputedStyle(this.track).direction === 'rtl';
      const step = matchMedia('(max-width: 749px)').matches ? (this.track.firstElementChild?.getBoundingClientRect().width || this.track.clientWidth) + 12 : this.track.clientWidth;
      const distance = Math.abs(this.track.scrollLeft) + step * direction;
      const position = Math.max(0, Math.min(this.track.scrollWidth - this.track.clientWidth, distance));
      this.track.scrollTo({ left: position * (rtl ? -1 : 1), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
    update() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      const position = Math.abs(this.track.scrollLeft);
      this.querySelector('.about-store__controls').hidden = max < 2;
      this.previous.disabled = position < 2;
      this.next.disabled = position >= max - 2;
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; this.observer?.disconnect(); }
  });
}
